import { usePage } from '@inertiajs/inertia-vue3';

export function useCookieConsent() {
    const consent = usePage().props.value.cookieConsent;

    function replaceYoutubeIframes(text) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const iframes = doc.querySelectorAll('iframe');

        iframes.forEach(iframe => {
            const iframeSrc = iframe.getAttribute('src');

            const link = document.createElement('a');
            link.href = iframeSrc;
            link.target = '_blank';
            link.innerText = iframeSrc;

            iframe.parentNode.replaceChild(link, iframe);
        });

        return doc.body.innerHTML;
    }

    return {
        consent,
        replaceYoutubeIframes,
    };
}
